<template>
  <div class="RmaViewSelector">
    <div v-if="loading" class="loader loader-positioning" />

    <div class="formSelector">
      <button @click="pagePrev" id="selector-left" v-if="showPrevButton">
        {{ $mlGet("prev") }}
      </button>
      <button @click="goToDashboard" id="selector-left">
        {{ $mlGet("backToDashboard") }}
      </button>
      <button @click="createNewRma" id="selector-left">
        {{ $mlGet("newRma") }}
      </button>
      <button @click="pageNext" id="selector-right" v-if="showNextButton">
        {{ $mlGet("next") }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue } from "vue-property-decorator";

class FieldError {
  constructor(fieldId: string, message?: string) {
    this.fieldId = fieldId;
    this.message = message || null;
  }
  fieldId: string;
  message: string | null;
}

@Component({
  components: {}
})
export default class UserDetail extends Vue {
  public warnings: FieldError[] = [];
  public currentWarning = 0;
  public loading = false;

  async createNewRma(): Promise<void> {
    this.loading = true;
    const hasChanged = await this.$changePage("ModelSelection", {
      clearHistory: true
    });
    if (hasChanged) this.$store.commit("cleanRma");
    this.loading = false;
  }

  goToDashboard(): void {
    this.$router.push("/");
  }

  @Prop({ default: true })
  showNextButton!: boolean;

  @Prop({ default: true })
  showPrevButton!: boolean;

  @Emit("page-next")
  pageNext(): string {
    return "TransportSelection";
  }

  @Emit("page-prev")
  pagePrev(): string {
    return "ModelSelection";
  }
}
</script>

<style scoped>
.RmaViewSelector {
  margin-top: 0;
}

.formSelector {
  margin-right: 1ex;
}

.formSelector button {
  font-family: overpass, arial;
  background-color: #da6f38 !important;
  border: none !important;
  font-size: 120%;
  font-weight: 400;
  border: none;
  padding: 8px 20px;
  margin: 8px 5px;
  color: white;
  width: auto;
  cursor: pointer;
}

#selector-left {
  float: left;
}

#selector-right {
  float: right;
}
</style>
